import React, { useEffect, useRef, useMemo, useState } from "react";
import { useSelector } from "react-redux";

const GapAnalysis = () => {

  const themeMode = useSelector((state) => state.themeMode);
  const chartRef = useRef(null);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
  const leftMenuVisibility = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.leftMenuVisibility;
  const currentSurveyInsightData = useMemo(() => {
    const activeTab = topMenuTabs.tabs.find(
      (tab) => tab.id === topMenuTabs.activeTab
    );
    return activeTab ? activeTab.states.currentSurveyInsightData : null;
  }, [topMenuTabs.tabs, topMenuTabs.activeTab]);
  console.log("download reports", currentSurveyInsightData);

  useEffect(() => {
    // console.log("strengths", currentSurveyInsightData?.reportdetail?.strengths);
  }, [currentSurveyInsightData]);

  return (
    <div>
      {currentSurveyInsightData?.report_detail?.scores !== undefined && (
        <div className="flex w-full min-h-screen flex-col px-12 pb-8">
          <h1
            className={`inline-flex flex-wrap items-center text-center md:text-left break-words text-[20px] sm:text-[26px] md:text-[30px] lg:text-[34px] font-bold  mb-10 ${themeMode === "dark" ? "text-[#44a5e4]" : "text-[#44a5e4]"
              }`}
          >
            GAP ANALYSIS REPORT
          </h1>
          <div className="flex flex-col w-full">
            <div className="flex w-full space-x-2">
              <div className="flex-1 text-center font-bold py-2 text-xs md:text-sm whitespace-nowrap bg-[#44a5e4] text-white" style={{ flex: 0.5 }}>
                SECTION
              </div>
              <div className="flex-1 text-center font-bold py-2 text-xs md:text-sm whitespace-nowrap bg-[#44a5e4] text-white" style={{ flex: 0.5 }}>
                SCORE
              </div>
              <div className="flex-1 text-center font-bold py-2 text-xs md:text-sm whitespace-nowrap bg-gray-700 text-white">
                CURRENT STATE
              </div>
              <div className="flex-1 text-center font-bold py-2 text-xs md:text-sm whitespace-nowrap bg-gray-700 text-white">
                TARGET STATE
              </div>
            </div>
            {currentSurveyInsightData?.report_detail?.scores?.sections.map(
              (section, index) => (
                <div key={index} className="flex w-full space-x-2">
                  <div className="flex-1 text-center items-center flex items-center justify-center" style={{ flex: 0.5 }}>
                    <h3
                      className={` ${themeMode === "dark" ? "text-white" : "text-black"
                        }`}
                    >
                      {section.name}
                    </h3>
                  </div>
                  <div className="flex-1 text-center flex items-center justify-center" style={{ flex: 0.5 }}>
                    <div className="relative w-full h-full flex justify-center items-center text-center">
                      <svg
                        className="w-16 h-16 transform -rotate-90"
                        viewBox="0 0 36 36"
                      >
                        <circle
                          className="text-gray-200 stroke-current"
                          strokeWidth="4"
                          cx="18"
                          cy="18"
                          r="16"
                          fill="none"
                        />
                        <circle
                          className={`${themeMode === "dark"
                              ? "text-[#44a5e4]"
                              : "text-[#44a5e4]"
                            } stroke-current`}
                          strokeWidth="4"
                          strokeDasharray="100, 100"
                          strokeDashoffset={`${100 - (section.score / 5) * 100}`}
                          cx="18"
                          cy="18"
                          r="16"
                          fill="none"
                          transform="rotate(0 18 18)"
                        />
                      </svg>
                      <div className="absolute ">
                      <span
                        className={`${themeMode === "dark"
                            ? "text-[#44a5e4]"
                            : "text-[#44a5e4]"
                          } top-5 font-bold text-lg`}
                      >
                        {section.score.toFixed(1)}
                      </span>
                      </div>
                      
                    </div>
                  </div>
                  <div className="flex-1 text-start py-2">
                    <h3
                      className={` ${themeMode === "dark" ? "text-white" : "text-black"
                        }`}
                    >
                      {currentSurveyInsightData?.report_detail?.gap_analysis.filter(x => x["section_name"] === section.name)?.map(y => y.current_state).join(" ")}
                    </h3>
                  </div>
                  <div className="flex-1 text-start py-2">
                    <h3
                      className={` ${themeMode === "dark" ? "text-white" : "text-black"
                        }`}
                    >
                      {currentSurveyInsightData?.report_detail?.gap_analysis.filter(x => x["section_name"] === section.name)?.map(y => y.target_state).join(" ")}
                    </h3>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
}
export default GapAnalysis;